import { render, staticRenderFns } from "./ResolutionToolbar.vue?vue&type=template&id=17cb0ead&scoped=true&"
import script from "./ResolutionToolbar.vue?vue&type=script&lang=js&"
export * from "./ResolutionToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionToolbar.vue?vue&type=style&index=0&id=17cb0ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cb0ead",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VSwitch,VTooltip})
